// extracted by mini-css-extract-plugin
export default {"container":"auth-gate-modal_container__NrumV","ctaCol":"auth-gate-modal_ctaCol__4p6dm","cta":"auth-gate-modal_cta__q6bzV","continueLink":"auth-gate-modal_continueLink__fTgC4"};